import Api from "@/api/Api";

export default new Api();
